import React from 'react';
import { Camera, ArrowRight } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';

const COPY = {
  before: { title: 'Des photos avant à prendre ?', cta: 'Prendre les photos avant', skip: 'Pas de photo avant' },
  after: { title: 'Des photos après à prendre ?', cta: 'Prendre les photos après', skip: 'Pas de photo après' },
};

/**
 * Rappel photo affiché juste après le pointage Début (avant) ou Fin (après) pour les métiers configurés dans
 * le back-office. `mandatory` masque le bouton « Pas de photo » (au moins une photo attendue).
 */
export function PhotoPromptDialog({ prompt, onTake, onSkip }) {
  const open = !!prompt;
  const kind = prompt?.kind || 'before';
  const copy = COPY[kind];
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !prompt?.mandatory) onSkip(); }}>
      <DialogContent className="max-w-sm w-[95vw] rounded-2xl" data-testid="photo-prompt-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="font-['Space_Grotesk'] flex items-center gap-2"><Camera className="h-5 w-5 text-[hsl(var(--primary))]" /> {copy.title}</DialogTitle>
          <DialogDescription data-testid="photo-prompt-text">
            {prompt?.ev?.label ? <span className="block font-medium text-foreground mb-1">{prompt.ev.label}</span> : null}
            {prompt?.message}
            {prompt?.mandatory ? <span className="block mt-1 text-xs">Au moins une photo est attendue par l'agence.</span> : null}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Button type="button" onClick={onTake} className="w-full h-12 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white" data-testid="photo-prompt-take">
            <Camera className="h-4 w-4 mr-1" /> {copy.cta}
          </Button>
          {!prompt?.mandatory && (
            <Button type="button" variant="outline" onClick={onSkip} className="w-full h-11 bg-card" data-testid="photo-prompt-skip">
              {copy.skip} <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
